function duplicate() {
  var isEmpty = false;
  $(this)
    .closest(".js-duplicate-box")
    .find('input:not([type="hidden"]),textarea')
    .each(function() {
      if ($(this).val() == "") {
        isEmpty = true;
        return false;
      }
    });

  if (isEmpty) {
    return false;
  } else {
  }

  var newele = $(this)
    .closest(".js-duplicate-box")
    .clone();
  var duplicateNum = $(".js-duplicate-button").index($(this));
  newele.find("input").val("");
  newele.find("textarea").val("");
  newele.find(".active").removeClass("active");
  newele
    .find(".js-thumb-image")
    .attr("src", "/static/website/images/dummy.png");
  newele.find(".input-count-text").html("");

  // 事業内容だけ
  if (newele.hasClass("js-services")) {
    newele.find("input").prop("required", false);
    newele.find("textarea").prop("required", false);
    newele.find("dd").removeClass("required");
    if (
      $(this)
        .closest(".js-duplicate-wrap")
        .find(".js-duplicate-box").length >= 3
    ) {
      alert("登録できる事業案内は3つまでです");
      return;
    }
  } else {
    newele.addClass("empty");
  }

  newele.appendTo($(this).closest(".js-duplicate-wrap"));

  duplicateRenumbering();

  // if(!newele.hasClass('js-services')){
  //   $(this).hide();
  //   $(this).closest('.js-duplicate-box').find('.js-duplicate-delete').show();
  // }
}

function duplicateRenumbering() {
  $(".js-duplicate-wrap").each(function() {
    $(this)
      .find(".js-duplicate-box")
      .each(function(index) {
        $(this)
          .find("textarea,input")
          .each(function() {
            var name = $(this).attr("name");
            $(this).attr("name", name.replace(/\d+/, index));
          });
      });
  });
}

function duplicateDelete() {
  var elenum = $(this)
    .closest(".js-duplicate-wrap")
    .find(".js-duplicate-box").length;
  if (elenum == 1) {
    return false;
  }

  $(this)
    .closest(".js-duplicate-box")
    .remove();
  // var num = $('.js-duplicate-box').length;
  // $('.js-duplicate-button').eq(num - 1).show();
  // if(num === 1){
  //   $('.js-duplicate-delete').hide();
  // }
  duplicateRenumbering();
}

// function duplicateCheck(){
//
//   $(this).closest('.js-duplicate-box').find('.js-duplicate-button').show();
//   $(this).closest('.js-duplicate-box').find('.js-duplicate-delete').show();
//
// }

$(document).on("click", ".js-duplicate-button", duplicate);
$(document).on("click", ".js-duplicate-delete", duplicateDelete);

$(document).on("change", ".js-duplicate-input", function() {
  duplicateFormCheck(this);
});

if ($(".js-duplicate-input").length > 0) {
  $(".js-duplicate-input").each(function() {
    duplicateFormCheck(this);
  });
}

function duplicateFormCheck(myself) {
  var text = $(myself).val();

  if (text != "") {
    $(myself)
      .closest(".js-duplicate-box")
      .find(".js-duplicate-button")
      .addClass("active");
  } else {
    $(myself)
      .closest(".js-duplicate-box")
      .find(".js-duplicate-button")
      .removeClass("active");
  }
}
